var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapContainer",staticStyle:{"height":"100%","border-radius":"12px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }